import ReactGA from 'react-ga4'
import LeftBar from '../home/components/leftBar'
import CaronaManager from './CaronaManager'
import './carona.css'

export default function CaronaInteligente() {
    ReactGA.send({
        hitType: 'pageview',
        page: '/ata-inteligente',
        title: 'Ata Inteligente',
    })
    return (
        <div className="carona-layout">
            <LeftBar />
            <CaronaManager />
        </div>
    )
}
